module.exports = __webpack_public_path__ + "media/images/bnr_special_gourmet-952bc99938b8145f26f9fbd3f2915d34.jpg";